import _isEmpty from 'lodash/isEmpty';
export function formatAuthor(author) {
  if (_isEmpty(author)) {
    return '';
  }
  var firstName = author.firstName,
    lastName = author.lastName,
    email = author.email;
  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }
  if (email) {
    return email;
  }
  return '';
}